// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1HwJz","colBig":"styles_colBig__140mB","colSmall":"styles_colSmall__1S792"};